<main class="mx-auto max-w-screen-xl px-4 py-6 shadow md:px-10">
  <p class="mb-2 text-3xl">{{ "NOT_FOUND.SORRY" | translate }}</p>
  <p class="mb-10 text-lg">{{ "NOT_FOUND.CODE" | translate }}</p>

  <gogis-button label="{{ 'MAP.GO_TO' | translate }}" [routerLink]="'/map'" />
</main>
